// extracted by mini-css-extract-plugin
export var acitonButtons = "_gy-0";
export var additionalIcon = "_gy-f";
export var block = "_gy-1";
export var blockContent = "_gy-7";
export var blockDescription = "_gy-8";
export var blockIcon = "_gy-9";
export var blockTitle = "_gy-6";
export var border = "_gy-a";
export var center = "_gy-l";
export var edge = "_gy-b";
export var edgeLabel = "_gy-c";
export var edgePath = "_gy-d";
export var error = "_gy-e";
export var flowchart = "_gy-g";
export var flowchartContent = "_gy-h";
export var highlighted = "_gy-3";
export var hover = "_gy-4";
export var icon = "_gy-i";
export var left = "_gy-m";
export var navButton = "_gy-j";
export var navButtons = "_gy-k";
export var right = "_gy-n";
export var selected = "_gy-2";
export var small = "_gy-5";